import {chakra,Box} from '@chakra-ui/react'
import React from 'react'
import {createPortal} from 'react-dom'

const isSSR = typeof document==='undefined'
export const Portal = chakra(({className,children})=>{
    if(isSSR)return null
    return(
        createPortal(<Box pos="absolute" zIndex={4} top="0" left='0' right='0' className={"myPortal "+className}>
            {children}
        </Box>,document.body)
    )



    
})